import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";

const mapStateToProps = (state) => {
  return {
    OwnerListData:state.common.OwnerListData,
    HostListData:state.common.HostListData
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getOwnerListDataAction: commonActions.getOwnerListData,
      getHostListDataAction: commonActions.getHostListData
    },
    dispatch
  );

const QueryStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default QueryStore;
